import React, { useState, useEffect, useCallback } from "react";
import "./index.css"; // Ensure this includes the ticker CSS
import LazyLoad from "react-lazyload";
import { AiFillHome } from "react-icons/ai";
import { FaBriefcase, FaGraduationCap, FaHandshake } from "react-icons/fa";
import { BsCurrencyDollar } from "react-icons/bs";

const Navbar = () => {
  const news = [
    "We Generate Solutions",
    "Innovation at Its Best!",
    "Your Vision, Our Mission",
    "Transforming Ideas into Reality",
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);

  // Using useCallback to avoid reinitializing the interval on each render
  const updateNews = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % news.length);
  }, []);

  useEffect(() => {
    const interval = setInterval(updateNews, 10000); // Change news every 10 seconds
    return () => clearInterval(interval); // Cleanup the interval on unmount
  }, [updateNews]);

  return (
    <header>
      {/* Left-aligned menu */}
      <nav className="menu-bar">
        <ul>
          <li>
            <a href="/home" rel="noopener noreferrer">
              <AiFillHome />
              <span>Home</span>
            </a>
          </li>
          <li>
            <a href="/outsourcing" rel="noopener noreferrer">
              <FaBriefcase />
              <span>Outsourcing</span>
            </a>
          </li>
          <li>
            <a href="/sales" rel="noopener noreferrer">
              <BsCurrencyDollar />
              <span>Sales</span>
            </a>
          </li>
          <li>
            <a href="/education" rel="noopener noreferrer">
              <FaGraduationCap />
              <span>Education</span>
            </a>
          </li>
          <li>
            <a href="/collaborations" rel="noopener noreferrer">
              <FaHandshake />
              <span>Collaborations</span>
            </a>
          </li>
        </ul>
      </nav>

      {/* Ticker Component */}
      <div className="mobile-ticker">
        <p>
          <span role="presentation">⇢</span> {/* Decorative arrow with role="presentation" */}
          {news[currentIndex]}
          <span role="presentation">⇠</span> {/* Decorative arrow with role="presentation" */}
        </p>
      </div>

      <LazyLoad height={100} offset={100} once>
      <a className="spici" href="#footerElements" aria-label="Scroll to Footer"></a>
      </LazyLoad>
      
    </header>
  );
};

export default Navbar;
